import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { api } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/admin/login", { password });
      localStorage.setItem("eterea_admin_pw", password);
      toast.success("Bienvenida ✦");
      navigate("/admin");
    } catch {
      toast.error("Contraseña incorrecta");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen">
      <Navbar />
      <section className="pt-40 pb-32 max-w-md mx-auto px-6">
        <p className="overline mb-3">Admin</p>
        <h1 className="font-display text-4xl text-white font-light tracking-tight mb-8">
          Entrar al estudio.
        </h1>
        <form onSubmit={submit} data-testid="admin-login-form" className="space-y-5">
          <div>
            <label className="field-label">Contraseña</label>
            <input data-testid="admin-password" type="password" required className="input-field"
              value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <button data-testid="admin-login-submit" type="submit" disabled={loading} className="btn-lilac w-full justify-center">
            {loading ? "Verificando…" : "Entrar"}
          </button>
        </form>
      </section>
      <Footer />
    </div>
  );
}
